import React from "react";
import { onlyIntegers } from "../../utils/utils";
import "./InputTel.css";

interface InputTelProps {
  id: string;
  areaCode: number;
  number: number;
  lateInit?: boolean;
  disabled?: boolean;
  error?: boolean;
  onChange: (areaCode: number, number: number) => void;
}

export const InputTel: React.FC<InputTelProps> = (props) => {
  const [number, setNumber] = React.useState(props.number);
  const [areaCode, setAreaCode] = React.useState(props.areaCode);

  React.useEffect(() => {
    setAreaCode(props.areaCode);
    setNumber(props.number);
  }, [props.lateInit, props.areaCode, props.number]);

  function JumpCaretToAreaCodeEnd(e: React.KeyboardEvent<HTMLInputElement>) {
    const inputTelNumber = document.getElementById(`${props.id}-number`) as HTMLInputElement;
    const inputTelAreaCode = document.getElementById(`${props.id}-area-code`) as HTMLInputElement;
    if (inputTelNumber.value.length === 0 && e.key === "Backspace") {
      inputTelAreaCode.focus();
      const length = inputTelAreaCode.value.length;
      inputTelAreaCode.setSelectionRange(length, length);
    }
  }

  function JumpCaretToNumberEnd(e: React.KeyboardEvent<HTMLInputElement>) {
    const inputTelNumber = document.getElementById(`${props.id}-number`) as HTMLInputElement;
    const inputTelAreaCode = document.getElementById(`${props.id}-area-code`) as HTMLInputElement;
    const rgx = /^[0-9]{1}$/;
    if (inputTelAreaCode.value.length === 2 && rgx.test(e.key)) {
      inputTelNumber.focus();
      const length = inputTelNumber.value.length;
      inputTelNumber.setSelectionRange(length, length);
    }
  }

  function handleAreaCodeChange(e: React.ChangeEvent<HTMLInputElement>) {
    const val = onlyIntegers(e.target.value);
    setAreaCode(val);
    // Use the current `number` state, not the stale `props.number`, otherwise
    // editing the DDD after typing the number reverts the number to its prop
    // value (mirrors handleNumberChange, which reads the `areaCode` state).
    props.onChange(val, number);
  }

  function handleNumberChange(e: React.ChangeEvent<HTMLInputElement>) {
    const newNumber = onlyIntegers(e.target.value);
    setNumber(newNumber);
    props.onChange(areaCode, newNumber);
  }

  function preventNonNumericInput(e: React.KeyboardEvent<HTMLInputElement>) {
    const specialKeysAllowed = ["Backspace", "ArrowLeft", "ArrowRight", "Tab"];
    if (specialKeysAllowed.includes(e.key)) return;

    const rgx = /^\d$/;
    if (!rgx.test(e.key)) {
      e.preventDefault();
    }
  }

  const isInvalid = props.error || areaCode.toString().length !== 2 || number.toString().length < 8;
  const containerClass = isInvalid ? "inputTelContainer inputTelError" : "inputTelContainer";

  return (
    <div className={containerClass} id={`${props.id}`}>
      <input
        type="text"
        className="inputTelAreaCode"
        id={`${props.id}-area-code`}
        value={areaCode}
        onKeyDown={preventNonNumericInput}
        onKeyUp={JumpCaretToNumberEnd}
        onChange={handleAreaCodeChange}
        maxLength={2}
        placeholder="DDD"
        disabled={props.disabled}
      />
      <input
        type="text"
        className="inputTelNumber"
        id={`${props.id}-number`}
        value={number}
        onKeyDown={preventNonNumericInput}
        onKeyUp={JumpCaretToAreaCodeEnd}
        onChange={handleNumberChange}
        maxLength={9}
        placeholder="Número"
        disabled={props.disabled}
      />
    </div>
  );
};
